export default __webpack_public_path__ + "static/media/yt.2702b55a.png";